import React, { useEffect, useState } from 'react';
import { Actions } from '../../../client/Actions';
import CustomContainer from '../../components/CustomContainer';
import CustomCard from '../../components/CustomCard';
import FormInputFile from '../../components/file/FormInputFile';
import { useLoaderContext } from '../../components/loader/LoaderContext';

const CommonImagesPage = () => {
  const { setLoader } = useLoaderContext();
  const [images, setImages] = useState([]);

  const loadImages = () => {
    setLoader(true);
    Actions.get('common-image', (data) => {
      setImages(data || []);
      setLoader(false);
    });
  };

  useEffect(loadImages, []);

  const fileEntries = images.map((image) => ({
    id: image.id,
    fileName: image.title || image.file?.fileName,
    filePath: image.file?.filePath,
    file: image.file,
  }));

  const createCommonImage = (file) => {
    setLoader(true);
    Actions.post(
      'common-image',
      {
        title: file.fileName,
        file,
      },
      loadImages,
      undefined,
      setLoader
    );
  };

  const deleteImage = (id) => {
    setLoader(true);
    Actions.delete(`common-image/${id}`, {}, loadImages, undefined, setLoader);
  };

  return (
    <CustomContainer title="Zdjęcia globalne">
      <CustomCard title="Zdjęcia" shadow={false} width={12}>
        <FormInputFile
          labelText="Wybierz plik"
          idName="common-images"
          formats={['PNG', 'JPG']}
          path="file/public"
          requestParameterName="file"
          fileNameField="fileName"
          filePathField="filePath"
          imagesParentStore={fileEntries}
          setImagesParentStore={() => {}}
          onUploaded={createCommonImage}
          onDeleteFile={deleteImage}
          uploadOnTop
          imageColumns={{ xs: 12, sm: 6, md: 3, lg: 2 }}
        />
      </CustomCard>
    </CustomContainer>
  );
};

export default CommonImagesPage;
